export const listboxPt = {
  emptyMessage: 'pv-listbox-empty-message'
};